module.exports = __webpack_public_path__ + "img/3.5a87433e.jpg";